import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./assest/css/style.css"; // <-- Includes the animation and input styles
import "./assest/css/animate.css";
import "aos/dist/aos.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import store from "./store";
import { GOOGLE_CLIENT_ID } from "./config";
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google";
const AuthGate = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const bannerRef = useRef(null);

  useEffect(() => {
    const storedAuth = sessionStorage.getItem("isAuthenticated");
    if (storedAuth === "true") {
      setAuthenticated(true);
    }
    // Initialize marquee animation
    // const marqueeElement = marqueeRef.current;
    // if (marqueeElement) {
    //   const textWidth = marqueeElement.scrollWidth;
    //   const containerWidth = marqueeElement.parentElement.clientWidth;
    //   const duration = Math.max(10, textWidth / 70); // Adjust speed based on text length

    //   marqueeElement.style.animation = `marquee ${duration}s linear infinite`;
    // }
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    if (username === "myfitspark" && password === "myfitspark@20230") {
      sessionStorage.setItem("isAuthenticated", "true");
      setAuthenticated(true);
    } else {
      setError("Invalid credentials. Please try again.");
    }
  };

  if (authenticated) {
    return children;
  }

  return (
    <div style={styles.overlay}>
      <div style={styles.popup} className="fade-in">
        {/* Banner above the form */}
        <div style={styles.bannerContainer}>
          <div ref={bannerRef} style={styles.bannerContent}>
            Our website is currently undergoing scheduled maintenance. Thank you
            for your patience.
          </div>
        </div>
        <h2 style={styles.title}>Authentication Required</h2>
        <form onSubmit={handleLogin} style={styles.form}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Username:</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={styles.input}
              placeholder="Enter username"
              required
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
              placeholder="Enter password"
              required
            />
          </div>
          {error && <p style={styles.error}>{error}</p>}
          <button type="submit" style={styles.button}>
            Continue
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.85)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10000,
  },
  popup: {
    backgroundColor: "#1e1e1e", // Dark background to match white text
    padding: "30px",
    borderRadius: "10px",
    width: "350px",
    boxShadow: "0 5px 25px rgba(0,0,0,0.3)",
    textAlign: "center",
  },
  bannerContainer: {
    position: "absolute",
    top: "0px",
    left: "0",
    right: "0",
    height: "40px",
    backgroundColor: "#e67e22",
    color: "white",
    overflow: "hidden",
    borderRadius: "5px 5px 0 0",
    display: "flex",
    alignItems: "center",
  },
  bannerContent: {
    position: "absolute",
    whiteSpace: "nowrap",
    animation: "slideInOut 15s linear infinite",
    fontWeight: "500",
    padding: "0 20px",
  },
  // banner: {
  //   position: "absolute",
  //   top: "40px",
  //   left: "0",
  //   right: "0",
  //   backgroundColor: "#e67e22",
  //   color: "white",
  //   padding: "8px 0",
  //   borderRadius: "5px 5px 0 0",
  //   overflow: "hidden",
  //   fontWeight: "500",
  // },
  // marqueeContainer: {
  //   width: "100%",
  //   overflow: "hidden",
  //   whiteSpace: "nowrap",
  //   position: "relative",
  // },
  // marqueeContent: {
  //   display: "inline-block",
  //   paddingLeft: "100%",
  //   animation: "marquee 15s linear infinite",
  // },
  title: {
    marginTop: 0,
    marginBottom: "25px",
    color: "#ffffff",
    fontSize: "24px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  formGroup: {
    marginBottom: "20px",
    textAlign: "left",
  },
  label: {
    display: "block",
    marginBottom: "8px",
    fontWeight: "500",
    color: "#dddddd",
  },
  input: {
    width: "100%",
    padding: "12px 15px",
    border: "1px solid #444",
    borderRadius: "6px",
    fontSize: "16px",
    boxSizing: "border-box",
    transition: "border-color 0.3s",
    backgroundColor: "#2b2b2b",
    color: "#ffffff",
  },
  error: {
    color: "#e74c3c",
    margin: "0 0 15px 0",
    fontSize: "14px",
  },
  button: {
    backgroundColor: "#2980b9",
    color: "white",
    padding: "14px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "600",
    transition: "background-color 0.3s",
    width: "100%",
  },
};
(function () {
  if (typeof window === "undefined" || !window.console) return;

  const originalError = window.console.error;

  window.console.error = function (...args) {
    const first = args[0];

    if (
      typeof first === "string" &&
      first.includes("ResizeObserver loop completed with undelivered notifications")
    ) {
      // Ignore this noisy LastPass + ResizeObserver error
      return;
    }

    // For everything else, keep normal behavior
    originalError.apply(window.console, args);
  };
})();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <Provider store={store}>
      {/* <AuthGate> */}
      <App />
      {/* </AuthGate> */}
    </Provider>
  </GoogleOAuthProvider>
);

reportWebVitals();
